const breakpoints = {
  max: {
    xxs: '1150px',
    xs: '1300px',
    sm: '1550px',
    md: '1775px',
    lg: '1920px'
  },
  min: {
    sm: '1551px',
    md: '1776px',
    lg: '1921px'
  }
};

export { breakpoints };
